import { DashType } from "@/features/dashboard";

export const MenuMap: Record<DashType.PerformanceType, string> = {
  change: "Daily Chg",
  perfW: "Weekly Perf",
  perf1M: "Monthly Perf",
  perf3M: "3-Month Perf",
  perf6M: "6-Month Perf",
  perfYtd: "YTD Perf",
  perfY: "Yearly Perf"
};

export const ReverseMenuMap = Object.entries(MenuMap).reduce(
  (a, [k, v]) => ({
    ...a,
    [v]: k as DashType.PerformanceType
  }),
  {} as Record<string, DashType.PerformanceType>
);
